const Lemo_Alert =
{
    id: '',
    showCloseButton: true,
    closeOnClick: true,
    text: '',
    textAlign: 'left',
    timeout: 30000,
    infoTimeout: 30000,
    dangerTimeout: 15000,
    warningTimeout: 5000,
    title: '',
    titleAlign: 'left',
    type: '',

    /**
     * Sestavi novy alert
     *
     * @param {string} type
     * @param {string} [title]
     * @param {string} [text]
     * @param {string} [id]
     * @param {int}    [timeout]
     */
    build: function (type, title, text, id, timeout) {
        // Nepodporovany typ alertu
        if ('info' !== type && 'success' !== type && 'warning' !== type && 'danger' !== type) {
            console.log("Unsuported alert type '" + type + "'");
            return false;
        }

        // Kontajner jeste neexistuje, vytvorime jej
        var container = $("#alert-container");
        if (!container.length) {
            container = $('<div id="alert-container"></div>');
            $("body").prepend(container);
        }

        // nastaveni vychoziho id
        if (typeof id === 'undefined' || id == null || !id.length) {
            id = 'default';
        }

        // zavreni vsech zacinajicich na id
        Lemo_Alert.closeByIdStart(id);

        // id musi byt unikatni
        id += '-' + this.getUniqueId();

        var alert = $('<div class="alert alert-' + type + '"></div>');

        // default timeout
        if ('undefined' === typeof timeout) {
            timeout = this.timeout;
            if ('danger' === type) {
                timeout = this.dangerTimeout;
            }
            if ('info' === type) {
                timeout = this.infoTimeout;
            }
            if ('warning' === type) {
                timeout = this.warningTimeout;
            }
        }

        // Nastavime ID
        if (typeof id !== 'undefined' && id != null && id.length) {
            alert.attr('id', 'alert-' + id);
        }

        // Pridame tlacitko na zavirani
        if (true === this.showCloseButton) {
            alert.append(
                $('<button></button>')
                    .attr('type', 'button')
                    .attr('class', 'close')
                    .attr('data-dismiss', 'alert')
                    .html('&times;')
            );
        }

        // Prelozime texty
        if (typeof Lemo_Translate.string === 'function') {
            title = Lemo_Translate.string(title);
            text = Lemo_Translate.string(text);
        }

        // Pridame titulek
        if ('' !== title) {
            alert.append(
                $('<strong class="text-' + this.titleAlign + '">' + title + '</strong>')
            );
        }

        // Pridame text
        alert.append(
            $('<p class="text-' + this.textAlign + '">' + text + '</p>')
        );

        if (true === this.closeOnClick) {
            alert.on('click', function () {
                alert.trigger('alert.close');
            }).css('cursor', 'pointer');
        }

        // Pridame alert do kontejneru
        container.append(alert);

        alert.slideDown(250);

        // Skryti alert po urcitem casovem useku
        if (timeout > 0) {
            window.setTimeout(Lemo_Alert.closeById.bind(null, id), timeout);
        }

        // Bind close event
        alert.one('alert.close', function () {
            alert.addClass('hidding');
            alert.promise().done(function () {
                $(this).slideUp(250, function () {
                    $(this).remove();
                });
            });
        });

        // Vyresetujeme nastaveni
        this.reset();
    },

    /**
     * Prida najednou nekolik alertu
     *
     * @param {object} messages
     * @return void
     */
    addMany: function (messages) {
        $(messages).each(function (i, m) {
            var id = '';
            if (m.hasOwnProperty('id')) {
                id = m.id;
            }
            var title = '';
            if (m.hasOwnProperty('title')) {
                title = m.title
            }
            if (m.hasOwnProperty('type') && m.hasOwnProperty('text')) {
                Lemo_Alert.build(m.type, title, m.text, id);
            }
        });
    },

    /**
     * Pridan novy alert typu Warning
     *
     * @param {string} text
     * @param {string} [id]
     * @param {int}    [timeout]
     * @return void
     */
    addDanger: function (text, id, timeout) {
        if (typeof id === 'undefined' || id == null || !id.length) {
            id = this.getUniqueId();
        }

        this.build('danger', 'Error', text, id, timeout);
    },

    /**
     * Pridan novy alert typu Informace
     *
     * @param {string} text
     * @param {string} [id]
     * @param {int}    [timeout]
     * @return void
     */
    addInfo: function (text, id, timeout) {
        if (typeof id === 'undefined' || id == null || !id.length) {
            id = this.getUniqueId();
        }

        this.build('info', 'Information', text, id, timeout);
    },

    /**
     * Pridan novy alert typu Success
     *
     * @param {string} text
     * @param {string} [id]
     * @param {int}    [timeout]
     * @return void
     */
    addSuccess: function (text, id, timeout) {
        if (typeof id === 'undefined' || id == null || !id.length) {
            id = this.getUniqueId();
        }

        this.build('success', 'Success', text, id, timeout);
    },

    /**
     * Pridan novy alert typu Warning
     *
     * @param {string} text
     * @param {string} [id]
     * @param {int}    [timeout]
     * @return void
     */
    addWarning: function (text, id, timeout) {
        if (typeof id === 'undefined' || id == null || !id.length) {
            id = this.getUniqueId();
        }

        this.build('warning', 'Warning', text, id, timeout);
    },

    /**
     * Zavre posledni alert bez ohledu na typ
     *
     * @return void
     */
    closeLast: function () {
        $('#alert-container').find('.alert:first').trigger('alert.close');
    },

    /**
     * Zavre všechny alerty
     *
     * @return void
     */
    closeAll: function() {
        var container = $('#alert-container');
        var alerts = container.find('[id^="alert-"]');
        $.each(alerts, function(i, alert) {
            $(alert).not('.hidding').trigger('alert.close');
        });
    },

    /**
     * Zavre alert se zadaným id, nebo alerty zacinajici na id
     *
     * @param {string} id
     * @return void
     */
    closeById: function (id) {

        if (typeof id === 'undefined' || id == null || !id.length) {
            return;
        }

        var container = $('#alert-container');
        var alert = container.find('#alert-' + id);

        if (alert.length) {
            $(alert).not('.hidding').trigger('alert.close');
            return;
        }

        Lemo_Alert.closeByIdStart(id);
    },

    /**
     * Zavre vsechny elementy zacinajici na id
     *
     * @param {string} id
     */
    closeByIdStart: function(id) {

        if (typeof id === 'undefined' || id == null || !id.length) {
            return;
        }

        var container = $('#alert-container');
        var alerts = container.find('[id^="alert-' + id + '-"]');
        $.each(alerts, function(i, alert) {
            $(alert).not('.hidding').trigger('alert.close');
        });
    },


    /**
     * Zavre posledni alert daneho typu
     *
     * @param {string} type
     * @return void
     */
    closeByType: function (type) {
        var container = $('#alert-container');
        var alert = container.find('.alert-' + type);
        if (alert.length) {
            alert.not('.hidding').filter(':first').trigger('alert.close');
        }
    },

    /**
     * Vyresetuje vlastnosti objektu
     *
     * @return void
     */
    reset: function () {
        this.showCloseButton = true;
        this.textAlign = 'left';
        this.timeout = 30000;
        this.titleAlign = 'left';
    },

    /**
     * Nastavi, zda se ma zobrazit tlacitko pro zavreni
     *
     * @param {boolean} showCloseButton
     */
    setShowCloseButton: function (showCloseButton) {
        this.showCloseButton = showCloseButton;
    },

    /**
     * Vrati, zda se ma zobrazit tlacitko pro zavreni
     *
     * @returns {boolean}
     */
    getShowCloseButton: function () {
        return this.showCloseButton;
    },

    /**
     * Nastavi, zda se ma alert zavrit on click
     *
     * @param {boolean} closeOnClick
     */
    setCloseOnClick: function(closeOnClick) {
        this.closeOnClick = closeOnClick;
    },

    /**
     * Vrati, zda se ma alert zavrit on click
     *
     * @returns {boolean}
     */
    getCloseOnClick: function() {
        return this.closeOnClick;
    },

    /**
     * Nastavi timeout
     *
     * @param {number} timeot
     */
    setTimeout: function (timeot) {
        this.timeout = timeot;
    },

    /**
     * Vrati timeout
     *
     * @returns {number}
     */
    getTimeout: function () {
        return this.timeout;
    },

    /**
     * Nastavi zarovnani titulku
     *
     * @param {string} align
     */
    setTitleAlign: function (align) {
        if ('left' === align || 'center' === align || 'right' === align || 'justify' === align) {
            this.titleAlign = align;
        } else {
            console.log("Unsuported title align '" + align + "'");
        }
    },

    /**
     * Vrati zarovnani titulku
     *
     * @returns {string}
     */
    getTitleAlign: function () {
        return this.titleAlign;
    },

    /**
     * Nastavi zarovnani textu
     *
     * @param {string} align
     */
    setTextAlign: function (align) {
        if ('left' === align || 'center' === align || 'right' === align || 'justify' === align) {
            this.textAlign = align;
        } else {
            console.log("Unsuported text align '" + align + "'");
        }
    },

    /**
     * Vrati zarovnani textu
     *
     * @returns {string}
     */
    getTextAlign: function () {
        return this.textAlign;
    },

    getUniqueId: function() {
        return Math.round(new Date().getTime() + (Math.random() * 100));
    }
}

window.Lemo_Alert || (window.Lemo_Alert = Lemo_Alert);
